import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactSession } from 'react-client-session'

function Logout() {
    const navigate = useNavigate()

    ReactSession.setStoreType("localStorage")

    useEffect(() => {
        const logged_user = ReactSession.get("logged_user")
        if(logged_user) {
            localStorage.removeItem("__react_session__");

            navigate("/");
        }else {
            navigate("/login");
        }
    }, [])
  return (
    <div>Logout</div>
  )
}

export default Logout